import React, { useEffect, useMemo, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import AntdDateTimePickerField from "../../../ui-compoenents/AntDateTimePickerField";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import samvatInitialValues from "../initialValues";
import SamvatSchema from "../schema";
import {
  createSamvatAsync,
  getSamvatAsync,
} from "../../../data/redux/features/samvat/slice";

const DATETIME_FORMAT = process.env.REACT_APP_DATETIME_FORMAT;

const AddSamvatFormModal = ({ selectedItem }) => {
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.samvat);

  useEffect(() => {
    const modalEl = document.getElementById("add_samvat_form_modal");

    const handleClose = () => {
      if (formRef.current) {
        formRef.current.resetForm();
      }
    };

    modalEl?.addEventListener("hidden.bs.modal", handleClose);
    return () => modalEl?.removeEventListener("hidden.bs.modal", handleClose);
  }, []);

  // useEffect(() => {
  //   dispatch(getNakshatrListAsync({}));
  // }, [dispatch]);

  const finalInitailValues = useMemo(() => {
    if (selectedItem) {
      return {
        start_time: selectedItem.start_time
          ? new Date(selectedItem.start_time)
          : null,
        end_time: selectedItem.end_time
          ? new Date(selectedItem.end_time)
          : null,
        value: selectedItem.value || null,
      };
    }
    return samvatInitialValues;
  }, [selectedItem]);

  return (
    <div className="modal fade" id="add_samvat_form_modal" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <Formik
            innerRef={formRef}
            initialValues={finalInitailValues}
            validationSchema={SamvatSchema}
            onSubmit={async (values, actions) => {
              try {
                const payload = {
                  start_time: dayjs(values.start_time).format(DATETIME_FORMAT),
                  end_time: dayjs(values.end_time).format(DATETIME_FORMAT),
                  value: values.value,
                };

                const result = await dispatch(
                  createSamvatAsync({ createSamavatValues: payload })
                ).unwrap();

                if (result) {
                  dispatch(getSamvatAsync());
                }

                document.getElementById("cancle")?.click();
                actions.resetForm();
              } catch (error) {
                console.error("❌ Failed to create Samvat:", error);
              }
            }}
            enableReinitialize
          >
            {({ values, isSubmitting }) => (
              <Form>
                <div className="modal-header border-bottom pb-4">
                  <h6 className="modal-title fw-bold">
                    {selectedItem ? "Edit" : "Add"} Samvat
                  </h6>

                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                  />
                </div>

                <div className="modal-body pt-0">
                  <div className="row p-2 g-3">
                    <div className="col-6">
                      <label className="form-label fw-semibold">
                        Start Time
                      </label>
                      <Field
                        name="start_time"
                        component={AntdDateTimePickerField}
                        placeholder="Select Start Date"
                      />
                      <div className="text-danger small">
                        <ErrorMessage name="start_time" />
                      </div>
                    </div>

                    <div className="col-6">
                      <label className="form-label fw-semibold">End Time</label>
                      <Field
                        name="end_time"
                        component={AntdDateTimePickerField}
                        startValue={values.start_time}
                        placeholder="Select End Date"
                      />
                      <div className="text-danger small">
                        <ErrorMessage name="end_time" />
                      </div>
                    </div>

                    <div className="col-12 d-flex flex-column">
                      <label className="form-label fw-semibold">Value</label>
                      <Field
                        name="value"
                        type="number"
                        className="form-control"
                        value={values?.value || ""}
                      />

                      <div className="text-danger small">
                        <ErrorMessage name="value" />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal-footer border-top bg-white pt-3">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    data-bs-dismiss="modal"
                    id="cancle"
                  >
                    Cancel
                  </button>

                  <button
                    type="submit"
                    className="btn btn-primary btn-sm"
                    disabled={isSubmitting || loading}
                  >
                    {selectedItem ? "Edit" : "Add"}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default AddSamvatFormModal;
